import * as React from 'react'
import DatePicker from './MomentDatePicker'

const MomentTimePicker = React.forwardRef((props, ref) => <DatePicker {...props} picker="time" mode={undefined} ref={ref} />)
MomentTimePicker.displayName = 'TimePicker'

const MomentTimeRangePicker = React.forwardRef((props, ref) => (
  <DatePicker.RangePicker {...props} picker="time" mode={undefined} ref={ref} />
))
MomentTimeRangePicker.displayName = 'TimeRangePicker'

// attach static
MomentTimePicker.RangePicker = MomentTimeRangePicker

export default MomentTimePicker
